import { lazy } from "react";

export const FirstStepLazy = lazy(() => import("./steps/first"));
export const SecondStepLazy = lazy(() => import("./steps/second"));
export const ThirdStepLazy = lazy(() => import("./steps/third"));
export const FourthStepLazy = lazy(() => import("./steps/fourth"));
export const ProjectSettingsLazy = lazy(
  () => import("./whiteLabel/projectSettings")
);
export const CustomDomainLazy = lazy(() => import("./whiteLabel/customDomain"));
export const AddDomainSubdomainLazy = lazy(
  () => import("./whiteLabel/customDomain/addDomainSubdomain")
);
export const MediaDesignLazy = lazy(() => import("./whiteLabel/mediaDesign"));
export const PromoCodesPageLazy = lazy(() => import("./promoCodesPage"));
export const TicketScannerPageLazy = lazy(() => import("./ticketScannerPage"));
export const ProfilePageLazy = lazy(() => import("./profilePage"));
export const PaymentPageLazy = lazy(() => import("./paymentPage"));
export const StatisticsPageLazy = lazy(() => import("./statisticsPage"));
export const PromotionPageLazy = lazy(() => import("./promotionPage"));
export const TicketScannerStepLazy = lazy(
  () => import("./steps/promotionScanner")
);
export const TicketDesignStepLazy = lazy(
  () => import("./steps/promotionDesign")
);
export const TicketBannerStepLazy = lazy(
  () => import("./steps/promotionBanner")
);
export const TicketShareStepLazy = lazy(() => import("./steps/promotionShare"));
export const TicketQrCodeStepLazy = lazy(
  () => import("./steps/promotionQrCode")
);
export const MyEventsPageLazy = lazy(() => import("./myEventsPage"));
export const EventPageLazy = lazy(() => import("./eventPage"));
export const ScansTablePageLazy = lazy(() => import("./scansTablePage"));
export const PaymentTablePageLazy = lazy(() => import("./paymentTablePage"));
export const AttendeesTablePageLazy = lazy(
  () => import("./attendeesTablePage")
);
export const ArchivePageLazy = lazy(() => import("./archivePage"));
export const AccessPageLazy = lazy(() => import("./accessPage"));
export const CheckpointAccessHistoryPageLazy = lazy(
  () => import("./accessHistoryPage")
);
export const TicketOfficePageLazy = lazy(() => import("./ticketOfficePage"));
export const PreOrderPageLazy = lazy(() => import("./preOrderPage"));
